export enum CptSearchSlideOutTabs {
  SUMMARY = 0,
  OON_PRICING = 1,
  ALERTS = 2
}
